module.exports = __webpack_public_path__ + "static/media/folderIcon.c04ba725.svg";